export default "__VITE_ASSET__00c61a23__"